﻿define(['jquery', 'pubsub', 'generalUtilities', 'addressUtility', 'agentsSearchUtilities', 'messageControl2'], function userGeoLocationControl($, pubsub, generalUtilities, addressUtility, agentsSearchUtilities) {
	'user strict';

	var module = {}, selectors = {};
	module.private = {};

	selectors.searchLocationButton = '.js-usergeolocation-btn';

	module.private.getLocation = function getLocation() {
		var getLocationDeferred = Q.defer();
		navigator.geolocation.getCurrentPosition(getLocationDeferred.resolve, getLocationDeferred.reject);
		return getLocationDeferred.promise;
	};

    module.private.geoCodePoint = function geoCodePoint(position) {
		// Request Geocode data - Address look up
		return addressUtility.geoCodePoint(position.coords.latitude, position.coords.longitude);
	};

	module.private.userSearchByLocation = function userSearchByLocation() {
        var getLocationPromise, getAddressPromise, result, lat, lng, address, countryId;
		
        result = {};
        lat = generalUtilities.prop(window, 'RESAAS.User2.Latitude');
        lng = generalUtilities.prop(window, 'RESAAS.User2.Longitude');
        address = agentsSearchUtilities.getUserLocation(generalUtilities.prop(window, 'RESAAS.User2'));
        countryId = generalUtilities.prop(window, 'RESAAS.User2.CountryId');

        if (lat && lng && address) {

            result = {
                lat: lat,
                lng: lng,
                addressName: address,
                countryCode: countryId
            }

            pubsub.publish('data.UserLocationBrowse', result);

        } else if (navigator.geolocation) {
			generalUtilities.disableAndWaitFor(selectors.searchLocationButton, 'data.UserLocationBrowse');

			getLocationPromise = module.private.getLocation();
            getAddressPromise = getLocationPromise.then(module.private.geoCodePoint)

            Q.all([getLocationPromise, getAddressPromise]).spread(function getResult(getLocationResult, getAddressResult) {

                // find the country code
                var countryCode;
                var addressResult = getAddressResult.response.data;
                var lastResult = addressResult[addressResult.length - 1];
                var i;
                var component;

                if (lastResult.address_components) {
                    for (i = 0; i < lastResult.address_components.length; i++) {
                        component = lastResult.address_components[i];
                        if (component.types[0] === 'country') {
                            countryCode = component.short_name;
                            break;
                        }
                    }
                }
				result = {
					lat: getLocationResult.coords.latitude,
					lng: getLocationResult.coords.longitude,
                    addressName: getAddressResult.response.data[0].formatted_address,
                    countryCode: countryCode
				}
			}).catch(function error() {
				pubsub.publish('uiAction.MessageAdd', { type: 'warning', message: RESAAS.Localization.Global.USER_GEOLOCATION_UNABLE_TO_RETRIEVE_LOCATION });
			}).finally(function publishResult() {
				pubsub.publish('data.UserLocationBrowse', result);
			});
		}
	};

	$('body').on('click', selectors.searchLocationButton, module.private.userSearchByLocation);

	return module;
});
